import { useUser } from './useUser';

/**
 * Hook to check if the user has permissions to access the Qodo Index
 * @returns true if the user has permissions to access the Qodo Index
 */
export const useQodoIndexPermissions = () => {
  const { user } = useUser();
  const { supportRagPages } = user || {};

  return supportRagPages;
};
